<template>
    <nav class="xtype-nav font-responsive mobile:hide">
        <ul>
            <li v-for="item in component_data.params.navs" :key="'lpnav'+item.target" :class="{'active': activeAnchor == item.target}"><a href="#" v-scroll-to="{el: item.target, offset: -140}">{{item.title}}</a></li>
        </ul>
    </nav>
</template>

<script>
export default {
    props: ['component_data'],
    data(){
        return {
            observeElements: {},
            anchors: [],
            activeAnchor: '',
            throttle: {
                timeout: null,
                limit: 100
            }
        }
    },
    methods: {
        isElementInViewport (el) {
            if (typeof el != "undefined") {
                var bounding = el.getBoundingClientRect();
                var windowHeight = (window.innerHeight || document.documentElement.clientHeight);

                return {
                    top: (bounding.top >= 0 && bounding.top <= windowHeight), // true gdy górna krawędź elementu jest w widoku
                    bottom: (bounding.bottom >= 0 && bounding.bottom <= windowHeight), // true gdy dolna krawędź elementu jest w widoku
                    inview: (bounding.top <= windowHeight && bounding.bottom >= 0),    // zwraca true gdy element pojawi się na ekranie (nie musi być widoczny w całości), działa także dla elementów większych niż obszar ekranu (górna krawędź elementu musi znajdować się wyżej niż dolny kraniec ekranu i analogicznie dolna krawędź elementu w tym samym czasie musi być niżej niż góra ekranu)      
                    above: (bounding.bottom < 0),    // zwraca true gdy cały obiekt jest powyżej ekranu
                    below: (bounding.top > windowHeight),    // zwraca true gdy cały obiekt jest poniżej ekranu
                    center: (bounding.top <= (windowHeight / 2) && bounding.bottom >=  (windowHeight / 2)) // true gdy element nakłada się na centrum ekranu (przyjmuje offset)   
                }
            }
        },
        setElements(){
            var vm = this

            vm.component_data.params.navs.forEach((el)=>{                
                vm.anchors.push(el.target)
                vm.$set(vm.observeElements, el.target, [])
            })

            vm.anchors.forEach((selector, i)=>{

                let element = document.querySelector(selector)
                let parameter = i+1 == vm.anchors.length ? 'last' : vm.anchors[i+1]

                while (element && element.id != parameter) {
                    if (element.nodeType === Node.ELEMENT_NODE) {
                        vm.observeElements[selector].push(element)
                    }
                    element = element.nextSibling
                }
            })
        },
        lookUpChanges(){
            var vm = this
            let active = vm.activeAnchor

            vm.anchors.forEach((selector)=>{
                vm.observeElements[selector].forEach((el)=>{
                    if (vm.isElementInViewport(el).center) {
                        active = selector
                    }
                })
            })

            vm.activeAnchor = active
        },
        handleScroll(){
            var vm = this

            if (vm.throttle.timeout === null) {

                //do stuff
                vm.lookUpChanges()

                vm.throttle.timeout = setTimeout(()=>{
                    clearTimeout(vm.throttle.timeout)
                    vm.throttle.timeout = null                    
                }, vm.throttle.limit)
            }       
        },
        
    },
    mounted(){
        this.$nextTick(()=>{
            this.setElements()
            // console.log(this.observeElements)
            window.addEventListener('scroll', this.handleScroll);
        })
    }

}
</script>

<style>
    .xtype-nav {
        position: fixed;
        width: 100%;
        background: #fff;
        z-index: 200;
        top: 70px;
    }
    .xtype-nav ul {
        list-style: none;
        margin: 0 auto;
        padding: 0;
        width: 83.3%;
        display: flex;
    }
    .xtype-nav li {
        display: inline-block
    }
    .xtype-nav a {
        display: block;
        font-family: Lato, sans-serif;
        font-size: 2em;
        color: #625D52;
        margin-right: 2em;
        padding: 1em 0;
    }

    .xtype-nav li a {
        overflow: hidden;
        position: relative;
    }

    .xtype-nav .active a,
    .xtype-nav a:hover {
        text-decoration: none;
        color: #E41429;
        
    }

    .xtype-nav li a:after{
        content: "";
        display: block;
        position: absolute;
        bottom: 0;
        height: 1px;
        width: 100%;
        background-color: #E41429;
        transform: translatex(120%);
        transition: transform .4s;
    }

    .xtype-nav li.active a:after{
        transform: translatex(0);
    }
    .xtype-nav li.active ~ li a:after{
        transform: translatex(-120%);
    }
</style>
 